/**
 * Created by mukund on 1/3/18.
 *
 * This directive is used for displaying a tooltip in cases where text is truncated, and an ellipsis is shown
 */

angular.module('mediacloudApp')
    .directive('responsiveTooltip', [function(){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/responsiveness/directives/responsive-tooltip/responsive-tooltip.html',
            scope: {
                content: '@'
            },
            link: function(scope, element, attrs){
                scope.tooltip = {};
                // scope.tooltip.enabled = element[0] && (element[0].scrollWidth > element.innerWidth());
                scope.tooltip.enabled = element[0] && (element[0].scrollWidth - element.innerWidth() > 4);

                element.hover(function(){
                    // scope.tooltip.enabled = element[0] && (element[0].scrollWidth > element.innerWidth());
                    scope.tooltip.enabled = element[0] && (element[0].scrollWidth - element.innerWidth() > 4);
                    scope.$apply();
                });
            }
        }

    }]);
